import type { WidgetCorrectnessDict } from 'screens/sheet/sheet-types';

import { createActionWithPayload, createAction } from 'actions/utils';

export const ACTIONS = {
  SET_ITEM_CORRECTNESS_DICTIONARY: 'SET_ITEM_CORRECTNESS_DICTIONARY',
  CLEAR_ITEM_CORRECTNESS_DICTIONARY: 'CLEAR_ITEM_CORRECTNESS_DICTIONARY',
} as const;

export const setItemCorrectnessDictionary = createActionWithPayload<
  typeof ACTIONS.SET_ITEM_CORRECTNESS_DICTIONARY,
  { widgetCorrectnessDict: WidgetCorrectnessDict }
>(ACTIONS.SET_ITEM_CORRECTNESS_DICTIONARY);

export const clearItemCorrectnessDictionary = createAction<
  typeof ACTIONS.CLEAR_ITEM_CORRECTNESS_DICTIONARY
>(ACTIONS.CLEAR_ITEM_CORRECTNESS_DICTIONARY);
